<template>
    <div>
        <div class="process-data-row">
            <span class="label">{{ $t('common.start') }}: </span> 
            <span class="value">{{ startedAt }}</span>
        </div>
        <div v-if="process.endedAt" class="process-data-row">
            <span class="label">{{ $t('common.end') }}: </span> 
            <span class="value">{{ endedAt }}</span>
        </div>
        <div class="process-data-row">
            <span class="label">{{ $t('gateway.processes.adsDownloaded') }}: </span> 
            <span class="value">
                <sui-label
                    :color="listingsCountColor"
                    size="tiny"
                    slot="trigger"
                >
                    {{ listingsCount }}
                </sui-label>
            </span>
        </div>
        <div class="process-data-row">
            <span class="label">{{ $t('common.status') }}: </span>
            <span class="value">
                <sui-label
                    :color="statusColor"
                    size="tiny"
                    slot="trigger"
                >
                    {{ status }}
                </sui-label>
            </span>
        </div>
    </div>
</template>

<script>
import { format } from 'date-fns';
import { processStatesColors } from '@/services/process-states';

export default {
    props: {
        process: {
            type: Object,
            required: true,
        },
    },

    computed: {
        status() {
            return this.process.currentState;
        },

        statusColor() {
            return processStatesColors[this.process.currentState];
        },

        listingsCount() {
            if (this.process.listingsCount === null) {
                return 0;
            }

            return this.process.listingsCount;
        },

        listingsCountColor() {
            if (this.process.listingsCount === null) {
                return 'black';
            }

            return (this.process.listingsCount === 0) ? 'red' : 'green';
        },

        startedAt() {
            return format(new Date(this.process.startedAt), 'dd/MM/yyyy HH:mm:ss');
        },

        endedAt() {
            return format(new Date(this.process.endedAt), 'dd/MM/yyyy HH:mm:ss');
        },
    },
};
</script>